<form nz-form class="form" nzLayout="horizontal">
  <div class="drawer-form-wrapper">
    <app-student-info-card
      [student]="caseParams.case?.student"
      [supervisorName]="caseParams.case?.supervisorName">
    </app-student-info-card>
    <app-behavior-info-card
      [mode]="mode"
      [behaviorCategoryName]="behavior?.behaviorCategoryName"
      [behaviorTypes]="behavior?.behaviorCategoryTypes">
    </app-behavior-info-card>

    <div *ngIf="isAppliedStep" class="header-with-cta mb-24">
      <h3 class="title s-18">Applied Strategies</h3>
      <button
        nz-button
        type="button"
        [disabled]="loading$ | async"
        (click)="startAddNew()"
        nzType="primary">
        Add New
      </button>
    </div>

    <nz-table
      *ngIf="isAppliedStep"
      #sortSelectionTable
      [nzData]="(flattenedStrategies$ | async) ?? []"
      [nzLoading]="loading$ | async"
      [nzFrontPagination]="false"
      [nzTotal]="(totalRows$ | async) ?? 0"
      [(nzPageIndex)]="defaultParams.pageIndex"
      [nzPageSize]="defaultParams.pageSize"
      (nzQueryParams)="onQueryParamsChange($event)"
      [nzScroll]="{ x: '1200' }">
      <thead>
        <tr>
          <th
            scope="col"
            nzWidth="180px"
            [nzSortFn]="true"
            [nzColumnKey]="'behaviourStrategyTypeName'">
            Behavior Strategy Type
          </th>
          <th
            scope="col"
            nzWidth="300px"
            [nzSortFn]="true"
            [nzColumnKey]="'title'">
            Title
          </th>
          <th
            scope="col"
            nzWidth="200px"
            [nzSortFn]="true"
            [nzColumnKey]="'statusId'">
            Status
          </th>
          <th
            scope="col"
            nzWidth="100px"
            [nzSortFn]="true"
            [nzColumnKey]="'createdDate'">
            Created Date
          </th>
          <th
            scope="col"
            nzWidth="100px"
            [nzSortFn]="true"
            [nzColumnKey]="'updatedDate'">
            Updated Date
          </th>
          <th scope="col" nzRight nzWidth="100px" nzAlign="center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let strategy of sortSelectionTable.data">
          <td
            [title]="strategy.behaviourStrategyTypeName"
            class="cursorPointer"
            (click)="openProactiveStrategyDrawer(strategy)"
            (keydown.enter)="openProactiveStrategyDrawer(strategy)">
            {{ strategy.behaviourStrategyTypeName }}
          </td>
          <td
            class="cursorPointer"
            (click)="openProactiveStrategyDrawer(strategy)"
            (keydown.enter)="openProactiveStrategyDrawer(strategy)"
            [title]="strategy.title">
            {{ strategy.title }}
          </td>
          <td [title]="getStatusText(strategy.statusId)">
            <div
              class="status"
              [class.active]="strategy.statusId === 1"
              [class.inactive]="strategy.statusId === 2">
              <span>{{ getStatusText(strategy.statusId) }}</span>
            </div>
          </td>
          <td [title]="strategy.createdDate | userDate: 'MM/dd/yyyy'">
            {{ strategy.createdDate | userDate: 'MM/dd/yyyy' }}
          </td>

          <td [title]="strategy.updatedDate | userDate: 'MM/dd/yyyy'">
            {{ strategy.updatedDate | userDate: 'MM/dd/yyyy' }}
          </td>
          <td nzRight nzWidth="100px">
            <div class="action-btn-wrapper">
              <button
                *ngIf="strategy.videoUrl"
                nz-button
                type="button"
                nzType="text"
                class="action-btn"
                (click)="openVideoUrl(strategy.videoUrl)">
                <svg-icon
                  [title]="'Play Video'"
                  src="/assets/icon/icon-play.svg"
                  class="icon s-20"
                  aria-label="Play"></svg-icon>
              </button>
              <button
                nz-button
                type="button"
                nzType="text"
                class="action-btn"
                (click)="openEditOwnStrategyComponent(strategy)">
                <svg-icon
                  [title]="'Edit Strategy'"
                  src="/assets/icon/icon-edit.svg"
                  class="icon s-20"
                  aria-label="Edit"></svg-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
  <div class="display-flexustify-content-between drawer-footer">
    <div class="footer-left" *ngIf="isAppliedStep">
      <button nz-button type="button" nzType="default" (click)="onCancelled()">
        Cancel
      </button>
    </div>
    <div
      class="footer-right"
      *ngIf="
        isAppliedStep &&
        caseParams.isContinueProcessing &&
        ((totalRows$ | async) ?? 0) > 0
      ">
      <button
        nz-button
        type="button"
        nzType="primary"
        class="ml-8"
        (click)="onContinueToData()">
        Continue to Data
      </button>
    </div>
  </div>
</form>

<nz-modal
  [(nzVisible)]="isVisible"
  [nzTitle]="modalHeaderTemplate"
  [nzFooter]="modalFooterTemplate"
  nzWidth="400px"
  nzCentered
  (nzOnCancel)="handleCancel()">
  <ng-template #modalHeaderTemplate>
    <div class="modal-header">
      <div class="modal-icon">
        <svg-icon
          src="/assets/icon/icon-print.svg"
          class="icon s-20"
          aria-label="Print"></svg-icon>
      </div>
      <h3 class="ant-modal-title">Behavior Strategies Added</h3>
      <p class="text s-14 fw-400 ant-modal-subtitle">
        The selected behavior strategies have been added to the student's plan.
      </p>
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"
        aria-label="Modal Circle"></svg-icon>
    </div>
  </ng-template>

  <ng-template #modalFooterTemplate>
    <div class="modal-footer">
      <button nz-button nzType="default" (click)="handleCancel()">
        Add More
      </button>
      <button
        type="button"
        nz-button
        [nzType]="'primary'"
        class="btn"
        (click)="handleOk()">
        Close
      </button>
    </div>
  </ng-template>
</nz-modal>

<app-video-modal [(visible)]="isVideoVisible" [videoUrl]="videoUrl">
</app-video-modal>

<ng-template #drawerBehaviorStrategies>
  <app-drawer-header
    [title]="'Manage Behavior Strategies'"
    [subtitle]="'Strategies'"
    [breadcrumbText]="caseParams.case?.student?.firstName || ''"
    (drawerClose)="closeManageBehaviorStrategiesDrawer()">
  </app-drawer-header>
</ng-template>
<ng-template #drawerBehaviorCreate>
  <app-drawer-header
    [title]="this.selectedId ? 'Edit Strategy' : 'Create Strategy'"
    subtitle="Strategies"
    [breadcrumbText]="caseParams.case?.student?.firstName || ''"
    (drawerClose)="closeCreateBehaviorStrategiesDrawer()">
  </app-drawer-header>
</ng-template>

<ng-template #drawerSelectionTitle>
  <app-drawer-header
    [title]="'Manage Behavior Strategies'"
    [subtitle]="'Strategies'"
    [breadcrumbText]="caseParams.case?.student?.firstName || ''"
    (drawerClose)="closeSelectionStepDrawer()">
  </app-drawer-header>
</ng-template>

<ng-template #drawerTitleData>
  <app-drawer-header
    [title]="'Data'"
    subtitle="''"
    [breadcrumbText]="''"
    (drawerClose)="closeDataDrawer()">
  </app-drawer-header>
</ng-template>
